module.exports = __webpack_public_path__ + "img/Efdot-Shirt-White-02.b47e19f7.jpg";